import { createRoot } from 'react-dom/client';
import ReactGA from 'react-ga';

import { App } from './App';

if (import.meta.env.VITE_GA_UA_ID) {
  ReactGA.initialize(import.meta.env.VITE_GA_UA_ID, { debug: true });
}

const MOUNT_NODE = document.getElementById('root');
if (MOUNT_NODE) {
  const root = createRoot(MOUNT_NODE);
  root.render(<App />);
  MOUNT_NODE.classList.add('loaded');
}
